import {
  addNavMenuItem,
  addNavMenuSection,
  addActionBarItem,
  registerCustomDetailComponent,
  registerPageTab,
  PageLocationId,
  registerBulkAction,
  DataService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { RequestPurchaseInfoComponent } from "./request-purchase-info/request-purchase-info.component";
import { ProductRequestPurchaseInfoComponent } from "./request-purchase-info/product/request-purchase-info.component";
import { map } from "rxjs";
import { checkProductStock } from "./check-product-stock";
import { ProductStockDisplayComponent } from "./ProductStockDisplay/product-stock-display.component";
import { RequestPurchaseTableComponent } from "./purchase-request/table/request-purchase-table.component";
import { DeletePurchaseNeededDocument } from "src/generated-gql/graphql";

export default [
  addNavMenuItem(
    {
      id: "purchase-needed",
      label: "nav.purchase-needed-list",
      routerLink: ["/extensions/purchase-needed"],
      icon: "bundle",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPurchaseRequest");
      },
    },
    "purchase-request"
  ),
  registerBulkAction({
    location: "purchase-needed-list",
    label: "Delete",
    icon: "remove",
    iconClass: "is-danger",
    onClick: (c) => {
      c.injector
        .get(DataService)
        .mutate(DeletePurchaseNeededDocument, {
          ids: c.selection.map((s) => s.id),
        }).subscribe(res => {
          c.injector.get(NotificationService).success("Deleted")
          c.hostComponent.refresh();
        })
    },
  }),
  addNavMenuItem(
    {
      id: "purchase-request",
      label: "nav.purchase-request-list",
      routerLink: ["/extensions/purchase-request"],
      icon: "bundle",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadPurchaseRequest");
      },
    },
    "purchase-request"
  ),
  registerCustomDetailComponent({
    locationId: "product-detail",
    component: ProductStockDisplayComponent,
  }),
  registerCustomDetailComponent({
    locationId: "product-variant-detail",
    component: RequestPurchaseInfoComponent,
  }),
  registerCustomDetailComponent({
    locationId: "product-detail",
    component: ProductRequestPurchaseInfoComponent,
  }),

  addActionBarItem({
    id: "check-stock",
    label: "requestPurchase.check-purchase-needed",
    locationId: "product-detail",
    buttonColor: "primary",
    icon: "sync",
    // routerLink: (route) => {
    //   const id = route.snapshot.params.id;
    //   return ["/extensions/links/generate", id];
    // },
    onClick: (event, context) => {
      //requestOrderDetail(context);
      checkProductStock(context);
    },
    buttonState: (context) => {
      return context.entity$.pipe(
        map((res) => {
          if (!res) {
            return {
              disabled: false,
              visible: false,
            };
          }

          if ((res as any).customFields.freeGifts) {
            return {
              disabled: true,
              visible: false,
            };
          }
          let visible = false;

          if (res) {
            visible = true;
          }

          return {
            disabled: false,
            visible,
          };
        })
      );
    },
  }),

  registerPageTab({
    location: "purchase-request-list" as PageLocationId,
    tab: "requestPurchase.Requested",
    route: "/extensions/purchase-request",
    //tabIcon: "star",
    component: RequestPurchaseTableComponent,
  }),

  registerPageTab({
    location: "purchase-request-list" as PageLocationId,
    tab: "requestPurchase.PendingApproval",
    route: "/extensions/purchase-request/pending-approval",
    //tabIcon: "star",
    component: RequestPurchaseTableComponent,
  }),

  registerPageTab({
    location: "purchase-request-list" as PageLocationId,
    tab: "requestPurchase.Approved",
    route: "/extensions/purchase-request/approved",
    //tabIcon: "star",
    component: RequestPurchaseTableComponent,
  }),

  registerPageTab({
    location: "purchase-request-list" as PageLocationId,
    tab: "requestPurchase.Rejected",
    route: "/extensions/purchase-request/rejected",
    //tabIcon: "star",
    component: RequestPurchaseTableComponent,
  }),
];
